(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmCall', CrmCall);

    CrmCall.$inject = ['$resource','DateUtils'];

    function CrmCall ($resource, DateUtils) {
        var resourceUrl =  'api/crm-calls/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: 'api/crm-calls/filter', method: 'GET', isArray: true},
            'pin': {url: 'api/crm-calls/pin', method: 'POST'}
        });
    }
})();
